import { render, staticRenderFns } from "./WChoicesEditor.vue?vue&type=template&id=7e691a96&"
import script from "./WChoicesEditor.vue?vue&type=script&lang=ts&"
export * from "./WChoicesEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports